import { Alignment, Button, Classes, Dialog, FormGroup, H5, Popover, Switch } from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { newEmpresa } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { ErrosNotasStore } from "../../stores/erros/ErrosNotasStore";
import { DateRangePicker } from "../utils/DateRangePicker";
import { Pager } from "../utils/Pager";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import * as moment from "moment";
import { IEmpresa } from "../../model";
import { formatCnpj } from "../../utils";
import { EmpresaSelect, filterEmpresa, renderEmpresa } from "../empresa/EmpresaSelect";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Box, Collapse, IconButton, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { toast } from "react-toastify";
import InfiniteScroll from "react-infinite-scroll-component";
import { AppIcon } from "../utils/AppIcon";

@observer
export class HistoricoNotasPage extends React.Component<{}, {}> {

  obs = observable({
    open_view_wars: false,
    open_view_erros: false,
    itens: [],
    openRow: false,
    currentpage: 1,
    importacao_id: "",
    loading: false,
    listErros: [] as any
  })

  constructor(props) {
    super(props);
    AppStore.setTitle("Erros de Cálculo");
  }

  componentDidMount() {

    this.handleDateChange(ErrosNotasStore.obs.selectedPeriod)

  }

  componentWillUnmount() {

    ErrosNotasStore.obs.imports_page = 1
    ErrosNotasStore.obs.imports_length = 0
    ErrosNotasStore.obs.imports = []
    ErrosNotasStore.obs.selectedEmpresa = newEmpresa()

  }

  handleDateChange = (val: any) => {
    var string = val.toString();
    var array = string.split(",");

    ErrosNotasStore.obs.date1 = moment(array[0]).format("YYYY-MM-DD")
    ErrosNotasStore.obs.date2 = moment(array[1]).format("YYYY-MM-DD")

    ErrosNotasStore.obs.selectedPeriod = val;

  };

  handleBuscaImportsPaged = async (page: number) => {

    if (ErrosNotasStore.obs.selectedEmpresa.cnpj == "") {
      toast.warning('Selecione uma empresa.', {});
      return
    }

    if (ErrosNotasStore.obs.date1 == null || ErrosNotasStore.obs.date2 == null || ErrosNotasStore.obs.date1 == "Data inválida" || ErrosNotasStore.obs.date2 == "Data inválida") {
      toast.warning('Selecione um período.', {});
      return
    }

    ErrosNotasStore.obs.imports_page = page

    await ErrosNotasStore.handleBuscaImportacoes(page, ErrosNotasStore.obs.selectedEmpresa.cnpj, ErrosNotasStore.obs.date1, ErrosNotasStore.obs.date2, ErrosNotasStore.obs.erros, ErrosNotasStore.obs.avisos);

  };

  async handleBuscaClick() {

    if (ErrosNotasStore.obs.selectedEmpresa.cnpj == "") {
      toast.warning('Selecione uma empresa.', {});
      return
    }

    if (ErrosNotasStore.obs.date1 == null || ErrosNotasStore.obs.date2 == null || ErrosNotasStore.obs.date1 == "Data inválida" || ErrosNotasStore.obs.date2 == "Data inválida") {
      toast.warning('Selecione um período.', {});
      return
    }

    ErrosNotasStore.obs.imports_page = 1

    await ErrosNotasStore.handleBuscaImportacoes(1, ErrosNotasStore.obs.selectedEmpresa.cnpj, ErrosNotasStore.obs.date1, ErrosNotasStore.obs.date2, ErrosNotasStore.obs.erros, ErrosNotasStore.obs.avisos);

    this.obs.listErros = []

  }

  async handleBuscaWars(row) {

    this.obs.itens = []
    this.obs.currentpage = 1
    this.obs.importacao_id = row.importacao_id
    this.obs.loading = true

    let resp = await ErrosNotasStore.handleImpotAvisos(1, row.importacao_id)

    if (resp.length) {

      this.obs.itens = resp

      this.obs.openRow = false

      this.obs.open_view_wars = true

    } else {

      toast.warn("Não ocorreu nenhum aviso durante a importação!")

    }

    this.obs.loading = false

  }

  async handleBuscaErrors(row) {

    this.obs.itens = []
    this.obs.currentpage = 1
    this.obs.importacao_id = row.importacao_id
    this.obs.loading = true

    let resp = await ErrosNotasStore.handleImpotErros(1, row.importacao_id)

    if (resp.length) {

      this.obs.itens = resp

      this.obs.open_view_erros = true

    } else {

      toast.warn("Não ocorreu nenhum erro durante a importação!")

    }

    this.obs.loading = false

  }

  onClose() {

    this.obs.open_view_erros = false
    this.obs.open_view_wars = false

    this.obs.itens = []

  }

  fetchMoreAvisos = async () => {

    this.obs.currentpage = this.obs.currentpage + 1

    let resp = await ErrosNotasStore.handleImpotAvisos(this.obs.currentpage, this.obs.importacao_id)

    this.obs.itens = [...this.obs.itens, ...resp]

  };

  fetchMoreErros = async () => {

    this.obs.currentpage = this.obs.currentpage + 1

    let resp = await ErrosNotasStore.handleImpotErros(this.obs.currentpage, this.obs.importacao_id)

    this.obs.itens = [...this.obs.itens, ...resp]

  };

  /**
 * Gerencia a seleção ou deseleção de uma linha específica na tabela.
 * 
 * @param {object} row - Objeto que representa a linha selecionada ou desmarcada.
 * @param {boolean} checked - Indica se a linha foi selecionada (`true`) ou desmarcada (`false`).
 * 
 */
  handleRowSelect = async (row, checked) => {

    if (checked) {

      this.obs.listErros.push(row.importacao_id);

    } else {

      let index = this.obs.listErros.indexOf(row.importacao_id);

      this.obs.listErros.splice(index, 1);

    }

  };

  /**
 * Gerencia a seleção ou deseleção de todas as linhas em uma tabela.
 * 
 * @param {boolean} check - Indica se as linhas estão sendo selecionadas (`true`) ou desmarcadas (`false`).
 * @param {array} row - Um array de objetos que representa as linhas a serem processadas.
 * 
 */
  handleRowSelectAll = async (check, row) => {
    if (check) {

      row?.map(value => {

        this.obs.listErros.push(value.importacao_id);

      });

    } else {

      this.obs.listErros = []

    }

  };

  /**
 * Função responsável por limpar os erros selecionados da lista e realizar a busca novamente.
 * 
 * - Se a lista de erros (`listErros`) contiver erros, ela tenta removê-los através do método `handleRemoveErros` da store `ErrosNotasStore`.
 * - Caso a remoção seja bem-sucedida, a lista de erros é limpa e a busca é acionada novamente.
 * - Se não houver erros na lista, uma mensagem de aviso é exibida para o usuário.
 * 
 * @async
 * @function handleLimparErros
 * 
 * @returns {void}
 */
  handleLimparErros = async () => {

    if (this.obs.listErros.length >= 1) {

      let rest = await ErrosNotasStore.handleRemoveErros(this.obs.listErros);

      if (rest) {

        this.obs.listErros = []

        this.handleBuscaClick()

      }

    } else {

      toast.warning('Você precisa selecionar os erros que deseja remover.', {});

    }

  };

  render() {

    let empresaText = ErrosNotasStore.obs.selectedEmpresa.razao_social != ""
      ? `${ErrosNotasStore.obs.selectedEmpresa.razao_social} (${formatCnpj(ErrosNotasStore.obs.selectedEmpresa.cnpj)})`
      : "Selecione uma empresa";

    function dateFormatter(cell, row) {
      return moment(cell).add(3, "hour").format("DD/MM/YYYY") + " ás " + moment(cell).add(3, "hour").format("HH:mm");
    };

    function stringFormatter(cell, row) {
      return (cell)?.toUpperCase();
    };

    function cnpjFormatter(cell, row) {
      if (row.cnpj) {
        let emp = EmpresaStore.getByCnpj(row.cnpj);
        if (emp) {
          return `${emp.razao_social} - ${formatCnpj(row.cnpj)}`
        }
      }

      return ""
    };

    const buttonWarDetalhes = (cell, row) => {
      return (
        <>
          {row.avisos &&
            <MDBBtn color="default" rounded size="sm" onClick={(e) => this.handleBuscaWars(row)} >
              <img src="/images/warning.png" width="18px" />
            </MDBBtn>
          }
        </>
      );
    }

    const buttonErrorDetalhes = (cell, row) => {
      return (
        <>
          {row.erros &&
            <MDBBtn color="default" rounded size="sm" onClick={(e) => this.handleBuscaErrors(row)} >
              <img src="/images/error.png" width="18px" />
            </MDBBtn>
          }
        </>
      );
    }

    function createData(
      _id: string,
      chave: string,
      cnpj_origem: string,
      cnpj_destino: string,
      itens: any
    ) {
      return {
        _id,
        chave,
        cnpj_origem,
        cnpj_destino,
        itens
      };
    }

    const Row = (props: { row: ReturnType<typeof createData>, openRow: any, setOpenRow: any }) => {
      const { row, openRow, setOpenRow } = props;
      const isOpen = openRow === row._id;

      return (<>
        <tr key={row._id}>
          <td>
            <IconButton
              size="small"
              onClick={() => setOpenRow(isOpen ? false : row._id)}
            >
              {isOpen ? <AppIcon name="keyboard_arrow_up" /> : <AppIcon name="keyboard_arrow_down" />}
            </IconButton>
          </td>
          <td>{row.chave}</td>
          <td>{formatCnpj(row.cnpj_origem || "")}</td>
          <td>{formatCnpj(row.cnpj_destino || "")}</td>
        </tr>

        <tr>
          <td style={{ paddingBottom: 0, paddingTop: 0, border: "none" }} colSpan={12}>
            <Collapse in={isOpen} timeout="auto" unmountOnExit style={{ paddingBottom: 5 }}>
              <Box style={{ padding: "10px 10px 0px 10px", maxHeight: 350, overflow: "auto", border: "1px solid #dee2e6", borderRadius: 10 }}>
                {row.itens?.map((value) => (
                  <p style={{ fontSize: 11, textAlign: "justify" }}>
                    <b><u>Item: {value.item}</u> - {value.descricao}: </b>{" "}{value.mensagem}
                  </p>
                ))}
              </Box>
            </Collapse>
          </td>
        </tr>
      </>)
    }

    const selectRow = {
      mode: "checkbox",
      clickToSelect: false,
      columnWidth: "40px",
      onSelect: this.handleRowSelect,
      onSelectAll: this.handleRowSelectAll,
      isSelected: true,
      selected: this.obs.listErros,
      bgColor: "rgba(27, 98, 111, 0.1)",
      unselectable: ErrosNotasStore.obs.imports.map(x => { return !x.erros ? x._id : null })
    };

    return (
      <div>

        <MDBRow>
          <MDBCol md="4">
            <div style={{ marginRight: 15 }}>
              <FormGroup label="Empresa" className="empresaSelect">
                <EmpresaSelect
                  items={EmpresaStore.sortedEmpresas}
                  itemRenderer={renderEmpresa}
                  itemPredicate={filterEmpresa}
                  onItemSelect={(e: IEmpresa) => ErrosNotasStore.obs.selectedEmpresa = e}
                  inputProps={{ placeholder: "Filtrar uma empresa" }}
                >
                  <Button
                    text={empresaText}
                    rightIcon="double-caret-vertical"
                    alignText={Alignment.LEFT}
                    style={{ width: "100%" }}
                  />
                </EmpresaSelect>
              </FormGroup>
            </div>
          </MDBCol>

          <MDBCol md="3">
            <FormGroup
              label="Período"
              className="inputsPeriodoCalculos"
            >
              <DateRangePicker
                onChange={this.handleDateChange}
                value={ErrosNotasStore.obs.selectedPeriod}
              />
            </FormGroup>
          </MDBCol>

          <MDBCol md="2">
            <MDBBtn
              className="btnDefault btnBuscarNfe mt25"
              onClick={() => this.handleBuscaClick()}
            >
              Buscar
            </MDBBtn>
          </MDBCol>

        </MDBRow>

        <FormGroup helperText={ErrosNotasStore.obs.erros && ErrosNotasStore.obs.avisos
          ? "Itens com erros ou avisos serão exibidos."
          : ErrosNotasStore.obs.erros
            ? "Somente itens com erros serão exibidos."
            : ErrosNotasStore.obs.avisos
              ? "Somente itens com avisos serão exibidos."
              : "Somente itens sem erros e avisos serão exibidos."}>

          <div className="nz-horizontal-form">
            <div className="horizontal">
              <Switch
                className="select-regras"
                label="Mostrar itens com erros"
                checked={ErrosNotasStore.obs.erros}
                onChange={(e: any) => {
                  ErrosNotasStore.obs.erros = e.target.checked
                  this.handleBuscaClick()
                }}
              />
            </div>
            <div className="horizontal">
              <Switch
                className="select-regras"
                label="Mostrar itens com avisos"
                checked={ErrosNotasStore.obs.avisos}
                onChange={(e: any) => {
                  ErrosNotasStore.obs.avisos = e.target.checked
                  this.handleBuscaClick()
                }}
              />
            </div>
          </div>
        </FormGroup>

        <h2 className="title">
          Empresa:{" "}
          <u>
            {ErrosNotasStore.obs.selectedEmpresa.razao_social ? ErrosNotasStore.obs.selectedEmpresa.razao_social : ""}
          </u>
        </h2>

        <div style={{ float: "right" }}>
          <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
            <MDBBtn className="btnDefault">Remover Erros</MDBBtn>
            <div>
              <H5>Confirmar exclusão?</H5>
              <p style={{ fontSize: 11 }}>Tem certeza de que deseja remover os erros desse item? Você não será capaz de recuperá-lo.</p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: 15,
                }}
              >
                <Button
                  className={Classes.POPOVER_DISMISS}
                  style={{ marginRight: 10 }}
                >
                  Cancelar
                </Button>
                <Button
                  intent="danger"
                  className={Classes.POPOVER_DISMISS}
                  onClick={() => this.handleLimparErros()}
                >
                  Remover
                </Button>
              </div>
            </div>
          </Popover>
        </div>

        <br />

        <BootstrapTable className="TableDefault" data={ErrosNotasStore.obs.imports} style={{ marginTop: 10 }} selectRow={selectRow}>
          <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%"> # </TableHeaderColumn>
          <TableHeaderColumn dataFormat={cnpjFormatter} width="50%">Empresa</TableHeaderColumn>
          <TableHeaderColumn dataFormat={dateFormatter} dataField="inserted_at" width="20%">Data Importação</TableHeaderColumn>
          <TableHeaderColumn dataFormat={stringFormatter} dataField="tipo" width="10%">Tipo</TableHeaderColumn>
          <TableHeaderColumn dataFormat={stringFormatter} dataField="modelo" width="10%">Modelo</TableHeaderColumn>
          <TableHeaderColumn dataFormat={stringFormatter} dataField="estado" width="10%">Estado</TableHeaderColumn>
          <TableHeaderColumn dataFormat={buttonWarDetalhes} width="10%">Avisos</TableHeaderColumn>
          <TableHeaderColumn dataFormat={buttonErrorDetalhes} width="10%">Erros</TableHeaderColumn>
        </BootstrapTable>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={ErrosNotasStore.obs.imports_page}
            totalCount={ErrosNotasStore.obs.imports_length}
            pageSize={20}
            onPageChange={page => this.handleBuscaImportsPaged(page)}
          />
        </div>

        <Dialog
          isOpen={this.obs.open_view_wars}
          onClose={() => this.onClose()}
        >
          <div className="flash-error">
            <div style={{ textAlign: "center", marginTop: 0 }}>
              <img
                src="/images/info_import.png"
                width={50}
                style={{ display: "inline-block" }}
              />
              <h3 style={{ color: "#ff944b" }}>Avisos ocorridos na Importação</h3>
            </div>

            <div style={{ padding: 5, border: "1px solid #dee2e6", borderRadius: 10 }}>
              <InfiniteScroll
                dataLength={this.obs.itens.length}
                next={this.fetchMoreAvisos}
                hasMore={true}
                height={350}
                loader={this.obs.loading ?
                  <div style={{ textAlign: "center" }}>
                    <div className="spinner-border" role="status">
                      <span className="sr-only"></span>
                    </div>
                  </div>
                  : ""}
              >
                <Table className="table" size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell />
                      <TableCell width={600} style={{ fontWeight: "bold" }}>Chave</TableCell>
                      <TableCell width={200} style={{ fontWeight: "bold" }}>CNPJ Origem</TableCell>
                      <TableCell width={200} style={{ fontWeight: "bold" }}>CNPJ Destino</TableCell>
                    </TableRow>
                  </TableHead>
                  {this.obs.itens?.map((row) => (
                    <Row key={row._id} row={row} openRow={this.obs.openRow} setOpenRow={(id) => this.obs.openRow = id} />
                  ))}
                </Table>
              </InfiniteScroll>
            </div>

          </div>

          <div style={{ textAlign: "center", marginTop: 10 }}>
            <Button text="Fechar" intent="primary" onClick={() => this.onClose()} />
          </div>

        </Dialog>

        <Dialog
          isOpen={this.obs.open_view_erros}
          onClose={() => this.onClose()}
        >
          <div className="flash-error">
            <div style={{ textAlign: "center", marginTop: 0 }}>
              <img
                src="/images/erro_calculo.svg"
                width={50}
                style={{ display: "inline-block" }}
              />
              <h3>Erros ocorridos na Importação</h3>

              <div style={{ padding: 5, border: "1px solid #dee2e6", borderRadius: 10 }}>
                <InfiniteScroll
                  dataLength={this.obs.itens.length}
                  next={this.fetchMoreErros}
                  hasMore={true}
                  height={350}
                  loader={this.obs.loading ?
                    <div className="spinner-border" role="status">
                      <span className="sr-only"></span>
                    </div>
                    : ""}
                >
                  {this.obs.itens?.map((row) => (
                    row.itens?.map((value) => (
                      <p>{value.mensagem}.</p>
                    ))
                  ))}
                </InfiniteScroll>
              </div>

            </div>
          </div>

          <div style={{ textAlign: "center", marginTop: 10 }}>
            <Button text="Fechar" intent="primary" onClick={() => this.onClose()} />
          </div>

        </Dialog>

      </div>
    );
  }
}

export default HistoricoNotasPage;
